module.exports = __webpack_public_path__ + "static/media/ddt-logo.33463208.svg";